export default function previewImage() {
    const result = this.$refs.cropper.getResult();
    const newTab = window.open();
    newTab.document.body.innerHTML = `<img src="${result.canvas.toDataURL("image/jpeg")}" style=" display: block; margin-left: auto; margin-right: auto; width: 50%;"></img>`;
}
